import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import senns from "@/assets/images/1.jpg";
import styles from "@/styles/houseOfSenco.module.scss";

const SennesFirst = () => {
  return (
    <div className={styles.sennes}>
      <div className={styles.container}>
        <div
          className={styles.image_sennes}
          onClick={() => window.open("https://www.sennes.in/", "_blank")}
          style={{ cursor: "pointer" }}
        >
          <Image src={senns} alt="" />
        </div>
        {/* <div className={styles.senns_overlay}>
            <div className={styles.senns_card}>
              <div className={styles.sen_text}>Sennes</div>
              <p>
                Explore the realm of handcrafted luxury with Sennes - a fusion
                of artistry and craftsmanship with Lab-grown Diamond Jewellery
                and Italian Designed Leather Bags and Accessories. Every piece
                is a work of art exuding ethereal grace. Experience the
                brilliance and sparkle of finest lab-grown diamonds and premium
                top-grain certified leather with Sennes.
              </p>
              <a>VISIT WEBSITE</a>
            </div>
          </div> */}
      </div>
    </div>
  );
};

export default SennesFirst;
